import React from 'react';
import {NavTabs} from '~/components/Tabs';
import {clientsLinks} from '~/modules/Clients';

export const ClientsTypeNavigation = () => <NavTabs tabs={[{
    children: 'Agencies',
    to: clientsLinks.agencies()
}, {
    children: 'Sellers',
    to: clientsLinks.sellers()
}]}/>;
